export const sellMyCar = "car/sell-my-car"